var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconOutlook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 116,
    viewBox: "0 0 126 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M125.073 60.9C125.079 59.9249 124.574 59.0174 123.74 58.5075H123.726L123.673 58.4785L80.3344 32.9005C80.1472 32.7745 79.953 32.6593 79.7526 32.5555C78.0793 31.6947 76.0915 31.6947 74.4181 32.5555C74.2177 32.6593 74.0235 32.7745 73.8364 32.9005L30.4974 58.4785L30.4451 58.5075C29.1205 59.3288 28.7144 61.0652 29.5381 62.3858C29.7808 62.7749 30.1151 63.0991 30.5119 63.3302L73.8511 88.9082C74.0388 89.0332 74.233 89.1484 74.4328 89.2533C76.1061 90.1141 78.0939 90.1141 79.7673 89.2533C79.9671 89.1484 80.1612 89.0332 80.3491 88.9082L123.688 63.3302C124.554 62.827 125.082 61.8993 125.073 60.9Z",
    fill: "#0A2767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5495 43.8219H63.9904V69.8145H35.5495V43.8219ZM119.255 17.4V5.50997C119.323 2.5372 116.963 0.0712344 113.982 0H40.1772C37.1956 0.0712344 34.8355 2.5372 34.9038 5.50997V17.4L78.5338 29L119.255 17.4Z",
    fill: "#0364B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9038 17.3999H63.9905V43.4999H34.9038V17.3999Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0774 17.3999H63.9907V43.4999L93.0774 69.5998H119.255V43.4999L93.0774 17.3999Z",
    fill: "#28A8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9907 43.5H93.0773V69.6H63.9907V43.5Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9907 69.5999H93.0773V95.6998H63.9907V69.5999Z",
    fill: "#0364B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5498 69.8145H63.9908V93.4436H35.5498V69.8145Z",
    fill: "#14447D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0771 69.5999H119.255V95.6998H93.0771V69.5999Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.74 63.1706L123.685 63.1996L80.3458 87.5016C80.1567 87.6175 79.9648 87.7277 79.764 87.8263C79.0279 88.1758 78.2285 88.3731 77.4139 88.4064L75.0462 87.0259C74.8461 86.9258 74.6519 86.8145 74.4644 86.6924L30.5436 61.7003H30.5233L29.0864 60.8999V110.095C29.1088 113.378 31.7949 116.021 35.087 116H119.165C119.214 116 119.258 115.977 119.31 115.977C120.006 115.932 120.691 115.79 121.346 115.553C121.629 115.434 121.903 115.292 122.164 115.13C122.358 115.02 122.693 114.779 122.693 114.779C124.183 113.68 125.065 111.944 125.072 110.096V60.8999C125.071 61.8409 124.562 62.7085 123.74 63.1706Z",
    fill: "url(#paint0_linear_20617_102604)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M122.745 60.7055V63.7216L77.4284 94.8298L30.5116 61.7205C30.5116 61.7045 30.4986 61.6915 30.4825 61.6915L26.1777 59.1105V56.9355L27.952 56.9065L31.7042 59.0525L31.7914 59.0815L32.1113 59.2845C32.1113 59.2845 76.2066 84.3695 76.323 84.4275L78.01 85.4135C78.1555 85.3554 78.3009 85.2975 78.4754 85.2395C78.5627 85.1814 122.251 60.6765 122.251 60.6765L122.745 60.7055Z",
    fill: "#0A2767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.741 63.1706L123.685 63.2025L80.3462 87.5044C80.1572 87.6204 79.9652 87.7306 79.7645 87.8292C78.0814 88.649 76.1131 88.649 74.43 87.8292C74.2306 87.7308 74.0365 87.6224 73.8482 87.5044L30.5092 63.2025L30.4569 63.1706C29.6202 62.7183 29.0956 61.8488 29.0869 60.8999V110.095C29.1077 113.377 31.7929 116.021 35.0843 116C35.0844 116 35.0845 116 35.0846 116H119.075C122.367 116.021 125.052 113.377 125.073 110.096C125.073 110.096 125.073 110.096 125.073 110.095V60.8999C125.072 61.8409 124.563 62.7085 123.741 63.1706Z",
    fill: "#1490DF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M80.977 87.145L80.3284 87.5075C80.1404 87.6268 79.9462 87.7363 79.7466 87.8352C79.032 88.1849 78.255 88.39 77.4604 88.4384L93.9497 107.88L122.713 114.791C123.502 114.197 124.129 113.417 124.537 112.52L80.977 87.145Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M83.9147 85.4978L80.3284 87.5075C80.1404 87.6268 79.9462 87.7362 79.7466 87.8352C79.032 88.1849 78.255 88.3899 77.4604 88.4384L85.1858 109.675L122.722 114.782C124.201 113.675 125.071 111.939 125.072 110.096V109.46L83.9147 85.4978Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.166 116H119.066C120.357 116.006 121.617 115.6 122.659 114.84L75.0437 87.0318C74.8437 86.9317 74.6494 86.8204 74.462 86.6983L30.5412 61.7061H30.5208L29.0869 60.8999V109.927C29.0836 113.278 31.8053 115.997 35.166 116C35.1659 116 35.1659 116 35.166 116Z",
    fill: "#28A8EA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M69.8077 28.5156V90.3726C69.8025 92.5414 68.4799 94.4908 66.4628 95.3026C65.8379 95.5703 65.165 95.7085 64.4848 95.7086H29.0864V26.0999H34.9038V23.2H64.4849C67.4233 23.2111 69.8014 25.5859 69.8077 28.5156Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M66.8991 31.4155V93.2724C66.9064 93.973 66.7575 94.6664 66.4628 95.3024C65.655 97.2875 63.7249 98.5899 61.5762 98.5997H29.0864V26.0999H61.5762C62.4202 26.0914 63.252 26.3013 63.9904 26.7089C65.7734 27.6045 66.8984 29.425 66.8991 31.4155Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M66.8991 31.4155V87.4725C66.8849 90.4009 64.5133 92.7744 61.5763 92.7998H29.0864V26.0999H61.5762C62.4202 26.0914 63.2519 26.3013 63.9904 26.7089C65.7734 27.6045 66.8984 29.425 66.8991 31.4155Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M63.9904 31.4158V87.4727C63.9873 90.4057 61.6092 92.7857 58.6676 92.8H29.0864V26.1001H58.6675C61.6089 26.1017 63.992 28.4803 63.9903 31.4129C63.9904 31.4139 63.9904 31.4148 63.9904 31.4158Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33157 26.1001H58.659C61.6036 26.1001 63.9906 28.48 63.9906 31.4158V84.5843C63.9906 87.5201 61.6036 89.9 58.659 89.9H5.33157C2.38699 89.9 0 87.5201 0 84.5843V31.4158C0 28.48 2.38706 26.1001 5.33157 26.1001Z",
    fill: "url(#paint1_linear_20617_102604)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6638 48.3951C17.9779 45.6038 20.0989 43.2678 22.7546 41.6874C25.6956 40.0087 29.0442 39.1718 32.4317 39.2688C35.5714 39.2009 38.6694 39.9944 41.3875 41.5627C43.943 43.0822 46.0013 45.3086 47.3124 47.9717C48.7403 50.9062 49.4519 54.1357 49.3892 57.3967C49.4584 60.8047 48.7263 64.1815 47.2513 67.2567C45.909 70.015 43.7855 72.3207 41.1431 73.889C38.3203 75.5053 35.1072 76.3196 31.8529 76.2438C28.6462 76.3209 25.4798 75.5184 22.6993 73.9238C20.1216 72.4023 18.0376 70.1734 16.6958 67.5031C15.2595 64.611 14.5394 61.4179 14.5958 58.1912C14.536 54.8122 15.2429 51.4634 16.6638 48.3951ZM23.1559 64.1421C23.8565 65.9067 25.0446 67.4372 26.5823 68.5559C28.1486 69.6473 30.024 70.2104 31.9342 70.1625C33.9686 70.2427 35.9738 69.6604 37.6469 68.5037C39.1651 67.3885 40.322 65.8539 40.9744 64.0899C41.7037 62.1198 42.0636 60.0329 42.036 57.9332C42.0586 55.8134 41.7203 53.7052 41.0354 51.6982C40.4306 49.8862 39.311 48.2884 37.8127 47.0988C36.1815 45.8873 34.1817 45.2728 32.1495 45.3588C30.1979 45.3084 28.2804 45.8759 26.6725 46.9799C25.1088 48.1033 23.8981 49.6473 23.1821 51.4314C21.5937 55.5208 21.5854 60.0527 23.1588 64.1479L23.1559 64.1421Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0771 17.3999H119.255V43.4999H93.0771V17.3999Z",
    fill: "#50D9FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20617_102604",
    x1: 77.0794,
    y1: 60.8999,
    x2: 77.0794,
    y2: 116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35B8F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28A8EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_20617_102604",
    x1: 11.1165,
    y1: 21.9465,
    x2: 52.6875,
    y2: 94.1611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1784D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#107AD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A63C9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOutlook);
export default __webpack_public_path__ + "static/media/icon-outlook.017296a2fe30b62d9b11700a94692231.svg";
export { ForwardRef as ReactComponent };